import { render } from "./AppFormReview.vue?vue&type=template&id=256dbe49&lang=pug"
import script from "./AppFormReview.vue?vue&type=script&lang=js"
export * from "./AppFormReview.vue?vue&type=script&lang=js"

import exportComponent from "P:\\Others\\nwlife.ru\\public_html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__